import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Illustration } from 'foundations-components/transitional/components/Illustration';

// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from 'LearningCenterUI/hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseProgressFeedback = ({
  children,
  'data-test-id': dataTestId,
  illustrationName
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": dataTestId,
    flexDirection: isMobile ? 'column' : 'row',
    inlineSize: "100%",
    justifyContent: "center",
    minBlockSize: !isMobile ? '412px' : undefined,
    children: [/*#__PURE__*/_jsx(Box, {
      basis: !isMobile ? '50%' : 'auto',
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        children: /*#__PURE__*/_jsx(Illustration, {
          marginBlockEnd: isMobile ? '400' : undefined,
          marginInlineEnd: !isMobile ? '1200' : undefined,
          name: illustrationName,
          width: "150px"
        })
      })
    }), /*#__PURE__*/_jsx(Box, {
      basis: !isMobile ? '50%' : 'auto',
      paddingInlineEnd: !isMobile ? '1500' : undefined,
      children: children
    })]
  });
};
export default PracticalExerciseProgressFeedback;